function sortBy(value) {
  // Get all blog posts (assuming they have a class like 'blog-post')
  var posts = document.querySelectorAll('.main-article__card');
  if(!posts) return;
  // Sort posts based on selected value
  posts = Array.from(posts).sort(function (a, b) {
    var aValue, bValue;
    switch (value) {
      case 'date-desc':
        aValue = new Date(a.getAttribute('data-date'));
        bValue = new Date(b.getAttribute('data-date'));

        return bValue - aValue;
      case 'date-asc':
        aValue = new Date(a.getAttribute('data-date'));
        bValue = new Date(b.getAttribute('data-date'));
        return aValue - bValue;
      case 'title-asc':
        return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
      case 'title-desc':
        return b.getAttribute('data-title').localeCompare(a.getAttribute('data-title'));
      default:
        return 0;
    }
  });
  // Update HTML with sorted posts
  var container = document.querySelector('.main-blog__items');
  container.innerHTML = '';
  posts.forEach(function (post) {
    container.appendChild(post);
  });
}

sortBy("date-desc");
